import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-4 scenario-share" }
const _hoisted_3 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && !_ctx.has_errors)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "btn btn-primary mb-5",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.printScenario && _ctx.printScenario(...args)))
            }, _cache[1] || (_cache[1] = [
              _createTextVNode("Print "),
              _createElementVNode("i", { class: "fas fa-print" }, null, -1)
            ])),
            _createElementVNode("h3", null, _toDisplayString(_ctx.scenario.patient_name), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.scenario.title), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatted_field_data, (field) => {
              return (_openBlock(), _createElementBlock("span", {
                key: field.id
              }, [
                _createElementVNode("h4", null, _toDisplayString(field.title), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.fields, (data) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: data.id
                  }, [
                    (field.fields.length > 1)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                          _createElementVNode("strong", null, _toDisplayString(data.title), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", {
                      innerHTML: data.value
                    }, null, 8, _hoisted_4)
                  ]))
                }), 128))
              ]))
            }), 128)),
            _cache[2] || (_cache[2] = _createElementVNode("h4", null, "Visit Objective", -1)),
            _createElementVNode("p", {
              innerHTML: _ctx.scenario.objective
            }, null, 8, _hoisted_5),
            _cache[3] || (_cache[3] = _createElementVNode("h4", null, "Target Audience", -1)),
            _createElementVNode("p", {
              innerHTML: _ctx.scenario.target_audience
            }, null, 8, _hoisted_6)
          ])
        ]))
      : (!_ctx.loading && _ctx.has_errors)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Error Loading Scenario", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.error_message), 1)
            ])
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}